import Error from '../Error/Error';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation();
    return (
        <>
            <Error message={t('notFound')} />
        </>
    );
};

export default NotFound;
